import { global } from "../../constants";

export const data = {
  banner: {
    base: "服务",
    background: global.banner + "4k.jpg",
    title: "保险",
    crumb: "保险",
  },
  icon: "fa-solid fa-shield-halved",
  shortDescription:
    "为保护资产、物流运营和员工福祉，确定并配置必要的保险和担保，针对海事及外贸行业量身定制解决方案。",
  title: "保险",
  features: {
    title: "保险",
    deliverables: "交付物",
    reqDocuments: "所需文件",
    subtitle:
      "针对船舶、货物、集装箱、合同担保及个人/企业项目，量身定制海事及外贸保险方案。",
    description: `我们设计并配置财产保险（H&M、P&I、民事责任、货物及集装箱）和人身保险（健康、寿险、旅行、伤残），以及定制的担保和信托。我们的服务涵盖风险评估、投保、出单及理赔管理，最大限度降低财务风险，保障运营连续性。`,
    viewDetail: "查看详情",
    feats: [
      {
        key: "hull_machinery",
        title: "船体与机械保险（H&M）",
        summary:
          "为船体、机械及船上设备提供保障，包括鉴定、碰撞及常见海事风险造成的损失。",
        details:
          "H&M方案适用于商用、渔业及辅助船舶：评估保险金额、免责条款、免赔额及国际航行专属条款。包含保险条款咨询、损失评估及与海事理算师协调。",
        deliverables: [
          "H&M保险方案（条款及保费）",
          "保险金额分析及建议",
          "理赔申报及管理流程",
        ],
        requiredDocs: [
          "船舶技术资料（长度、年份、船旗）",
          "维护及历史理赔记录",
          "安全证书及注册文件",
        ],
        icon: "fa-solid fa-ship",
        image: global.services + "insurance/1.webp",
      },
      {
        key: "pandi",
        title: "P&I责任与赔偿保险",
        summary:
          "为船东及运营商提供民事责任保障：第三方损害、污染、船员责任及货物索赔。",
        details:
          "协助加入P&I俱乐部或同类方案，设定自留额并协调理赔。明确污染、通过船闸/港口及货物或第三方损害责任范围。",
        deliverables: [
          "P&I需求评估",
          "入会/续保及保障函管理",
          "P&I理赔处理流程",
        ],
        requiredDocs: [
          "吨位及运营详情",
          "理赔历史",
          "既往保单及P&I证书（如有）",
        ],
        icon: "fa-solid fa-hand-holding-water",
        image: global.services + "insurance/2.webp",
      },
      {
        key: "responsabilidad_civil",
        title: "民事责任与特殊风险保险",
        summary:
          "为港口运营、物流及相关活动提供一般及有限民事责任保障，并根据业务纳入特殊风险。",
        details:
          "为企业设计民事责任保单（含服务场所、报关代理、仓储及物流运营商）。评估第三方损害、污染、职业责任及特殊风险（恶意行为、盗窃、政治风险如适用）保障需求。",
        deliverables: [
          "民事责任保险方案（限额及免责）",
          "保障缺口分析",
          "第三方合同推荐条款",
        ],
        requiredDocs: ["业务及运营描述", "客户/供应商合同", "理赔及应急历史"],
        icon: "fa-solid fa-gavel",
        image: global.services + "insurance/3.webp",
      },
      {
        key: "carga_multimodal",
        title: "货物保险——海运、陆运与空运",
        summary: "为货物在海运、陆运及空运各阶段提供全险/指定风险保障。",
        details:
          "为进出口设计货物保险方案，涵盖多式联运、丢失、损坏、盗窃及物流应急。包含合并、转运及仓储条款。",
        deliverables: [
          "各运输方式货物保险条款",
          "按货物类型估算保费表",
          "保单及批单出具流程",
        ],
        requiredDocs: [
          "货物清单及商业价值",
          "路线及运营商信息",
          "运输文件（提单、运单、指引）",
        ],
        icon: "fa-solid fa-boxes-stacked",
        image: global.services + "insurance/4.webp",
      },
      {
        key: "contenedores",
        title: "集装箱保险——在途及港区",
        summary:
          "为集装箱在运输途中或港区堆场存放期间提供专属保障，包括丢失、损坏及恶意破坏。",
        details:
          "为满载或空集装箱提供专属保单及条款，扩展至搬运、堆场存放及第三方责任。可按单箱或车队投保，并根据堆场时长调整。",
        deliverables: [
          "单箱/车队保险方案",
          "堆场及在途保障批单",
          "申报及文件清单",
        ],
        requiredDocs: [
          "集装箱清单及状态",
          "与码头及运营商合同",
          "丢失/损坏历史",
        ],
        icon: "fa-solid fa-box",
        image: global.services + "insurance/5.webp",
      },
      {
        key: "fianzas_garantias",
        title: "担保与保证金——投标维持、履约及预付款",
        summary:
          "为招标、运营合同及海关义务办理担保与保证金；为报关代理、仓储及供应商提供保障。",
        details:
          "办理银行担保及保证金，涵盖投标维持、履约、劳动预付款、临时准入及罚款。就最适合的担保类型、出具要求、期限及理赔管理提供咨询。",
        deliverables: [
          "按需担保/保证金方案",
          "出具材料支持",
          "到期前跟踪与管理",
        ],
        requiredDocs: [
          "招标条件或合同",
          "申请人财务资料",
          "金额及担保期限说明",
        ],
        icon: "fa-solid fa-file-shield",
        image: global.services + "insurance/6.webp",
      },
      {
        key: "fideicomiso",
        title: "客户定制信托",
        summary: "为外贸或特定项目提供资金管理、担保及资产安全的信托结构。",
        details:
          "设计信托以保障合同义务、管理保证金、项目资金或作为资产买卖的托管机制。包含信托契约起草、受托人选择及资金释放规则设定。",
        deliverables: [
          "信托方案建议",
          "信托契约草稿",
          "受托人及受益人操作指南",
        ],
        requiredDocs: [
          "信托目的及金额",
          "各方及受益人信息",
          "拟信托资产法律文件",
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "insurance/7.webp",
      },
      {
        key: "seguros_personales",
        title: "个人及企业保险",
        summary: "为拉美及美国员工和高管设计健康、寿险、旅行及伤残保障方案。",
        details:
          "提供个人及团体保单：健康保险（本地及区域计划）、拉美寿险及美国专属保障、国际旅行援助、临时或永久伤残保险，以及针对职业风险和特殊暴露的解决方案。包含福利分析、保费估算及共保选项。",
        deliverables: [
          "福利方案建议（个人/企业）",
          "保障及保费对比",
          "入会及理赔说明",
        ],
        requiredDocs: [
          "员工/受益人名单",
          "基础医疗信息（按保险公司要求）",
          "具体需求及所需保障范围",
        ],
        icon: "fa-solid fa-user-shield",
        image: global.services + "insurance/8.webp",
      },
      {
        key: "gestion_siniestros",
        title: "理赔管理与预防",
        summary:
          "为理赔处理提供全程协助：申报、核算、谈判及结案，并开展预防项目以降低发生率。",
        details:
          "协调理赔申报、与理算师及保险公司沟通、评估鉴定报告及赔偿谈判。开展预防项目、风险审计及培训，减少理赔频率及影响。",
        deliverables: [
          "理赔管理流程",
          "理赔办理及跟踪协助",
          "理赔后改进/预防报告",
        ],
        requiredDocs: [
          "理赔报告及事件记录",
          "合同文件及保单",
          "鉴定报告及照片证据",
        ],
        icon: "fa-solid fa-file-medical",
        image: global.services + "insurance/9.webp",
      },
    ],
  },
  ctaText: "申请保险报价",
  ctaLink: "/contact?service=asset-personal-insurance",
};
